import React, { useEffect } from "react";

const DEFAULT_DURATION_MS = 4000;

export default function SplashScreen({ onComplete, durationMs = DEFAULT_DURATION_MS }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      document.body.style.overflow = "";
      document.body.style.overflowY = "auto";
      onComplete?.();
    }, durationMs);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "";
      document.body.style.overflowY = "auto";
    };
  }, [onComplete, durationMs]);

  // Preload landing page videos zodra het laadscherm zichtbaar is (vooral mobiele video)
  useEffect(() => {
    const v1 = document.createElement("video");
    v1.preload = "auto";
    v1.src = "/video.mov";
    v1.setAttribute("data-splash-preload", "1");
    v1.style.cssText = "position:absolute;width:0;height:0;pointer-events:none;opacity:0;";
    document.body.appendChild(v1);
    v1.load();
    const v2 = document.createElement("video");
    v2.preload = "auto";
    v2.src = "/Mobile%20video.mp4";
    v2.setAttribute("data-splash-preload", "1");
    v2.style.cssText = "position:absolute;width:0;height:0;pointer-events:none;opacity:0;";
    document.body.appendChild(v2);
    v2.load();
    return () => {
      v1.remove();
      v2.remove();
    };
  }, []);

  return (
    <div
      className="splash-screen-root"
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        width: "100%",
        height: "100%",
        padding: "env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left)",
        zIndex: 99999,
        background: "linear-gradient(135deg, #3399FF 0%, #2288dd 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <div className="splash-text-wrap" style={{ padding: "0 24px" }}>
        {/* Achterste laag: grijs, altijd zichtbaar, exact in het midden */}
        <span className="splash-text splash-screen-text splash-text-gray" aria-hidden="true">Slimmer af</span>
        {/* Voorste laag: wit, statisch op dezelfde plek, van links naar rechts zichtbaar (clip) */}
        <div className="splash-fill-wrap" aria-hidden="true">
          <span className="splash-text splash-screen-text splash-text-white">Slimmer af</span>
        </div>
      </div>
    </div>
  );
}
